function formatNumber(value, options = {}) { if (value === null)
    return value; const { locale = 'es-CL', ...numberFormatOptions } = options; const formatter = new Intl.NumberFormat(locale, numberFormatOptions); return formatter.format(value); }
function roundNumber(value, decimals = 1) {
    if (value === null)
        return value; // eslint-disable-next-line no-magic-numbers
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}
export { formatNumber, roundNumber };
